import AbstractNode from './AbstractNode';
import {replaceAndSelectNode} from "../helper/nodeSelection";

export default class TableOfContents extends AbstractNode {
  get name() {
    return 'table_of_contents';
  }

  get schema() {
    return {
      attrs: {
        levels: {default: [1, 2, 3]}
      },
      content: 'block*',
      group: 'block',
      selectable: true,
      draggable: true,
      parseDOM: [
        {
          tag: 'div.table-of-contents',
          getAttrs: function getAttrs(dom) {
            return {
              levels: dom.getAttribute('data-levels')?.split(',').map(level => parseInt(level))
            };
          },
        }],
      toDOM: node => [
        'div', {
          class: 'table-of-contents',
          ['data-levels']: node.attrs.levels
        }, 0],
    };
  }

  get parseMarkdown() {
    return {
      block: 'table_of_contents', getAttrs: token => ({
        levels: token.attrGet('levels')
      }),
    };
  }

  toMarkdown(state, node) {
    const {levels} = node.attrs;

    state.ensureNewLine();
    state.write('[TOC');

    if (levels) {
      state.write(` levels=${levels?.join(',')}`);
    }

    state.write(']');

    state.closeBlock(node);
  }

  commands({schema}) {
    return {
      createTableOfContents: () => view => replaceAndSelectNode(view, schema.nodes.table_of_contents.create())
    };
  }
}